import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Sparkles, Plus, ArrowLeft } from 'lucide-react';
import { PathCard } from '../components/PathCard';
interface ChoosePathScreenProps {
  onNext: (path: 'template' | 'ai' | 'scratch') => void;
  onBack?: () => void;
}
export function ChoosePathScreen({
  onNext,
  onBack
}: ChoosePathScreenProps) {
  return <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-[#0f0f2d]" data-id="element-84">
      <div className="max-w-5xl w-full" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-14" data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-87">
            Let's build your first funnel
          </h2>
          <p className="text-[#8b8bab] text-lg" data-id="element-88">
            Choose how you want to get started.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-89">
          <PathCard title="Start with a Proven Template" description="Choose from high-performing funnels used by thousands of entrepreneurs." icon={LayoutGrid} isRecommended={true} variant="primary" onClick={() => onNext('template')} delay={0.1} data-id="element-90" />

          <PathCard title="Let AI Build One for You" description="Answer a few questions and we'll generate a complete funnel to customize." icon={Sparkles} variant="secondary" onClick={() => onNext('ai')} delay={0.2} data-id="element-91" />
        </div>

        <div className="mb-10" data-id="element-92">
          <PathCard title="Build from Scratch" description="Start with a blank canvas. Best for experienced funnel builders." icon={Plus} variant="tertiary" onClick={() => onNext('scratch')} delay={0.3} data-id="element-93" />
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} className="flex items-center justify-center gap-6" data-id="element-94">
          {onBack && <button onClick={onBack} className="flex items-center gap-2 text-[#5a5a7a] hover:text-white text-sm font-medium transition-colors" data-id="element-95">
              <ArrowLeft size={16} data-id="element-96" />
              Back
            </button>}
          <span className="text-[#3a3a5a]" data-id="element-97">·</span>
          <button onClick={() => onNext('template')} className="text-[#5a5a7a] hover:text-white text-sm font-medium transition-colors" data-id="element-98">
            Skip for now
          </button>
        </motion.div>
      </div>
    </div>;
}